import service from '@/store/services/settings/activity-guidances-service';

const state = {
    list: {},
    activityGuidance: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, activityGuidance) => {
        state.activityGuidance = activityGuidance;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(activityGuidance => {
                commit('SET_RESOURCE', activityGuidance);
            });
    },

    view ({ commit, dispatch }, params) {
        return service.view(params)
            .then(activityGuidance => {
                commit('SET_RESOURCE', activityGuidance);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(activityGuidance => {
                commit('SET_RESOURCE', activityGuidance);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((activityGuidance) => {
                commit('SET_RESOURCE', activityGuidance);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((activityGuidance) => {
                commit('SET_RESOURCE', activityGuidance);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    activityGuidance: state => state.activityGuidance,
    dropdown: (state) => {
        return state.list.map(activityGuidance => ({
            id: activityGuidance.id,
            name: activityGuidance.request_type
        }));
    },
    url: state => state.url,
};

const activityGuidances = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default activityGuidances;
